import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { StaffManagerFormAtomProps } from "../StaffManagerForm.types";

const EmailField = ({ control }: StaffManagerFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="email"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Input
          value={value}
          onChange={onChange}
          label={t("Email")}
          placeholder={t("Enter Email")}
          errorMessage={error?.message}
          data-testid="staff-manager--email"
        />
      )}
    />
  );
};

export default EmailField;
